import { create } from 'zustand';

export type TQuizzCorrectAnswer = {
  quizId: string;
  isCorrect: boolean;
  correctAnswer: number;
  correctAnswerFact: string;
};

export type TQuizzAnswer = {
  quizId: string;
  selectedAnswer: number;
};

export type TQuizzResult = {
  correct: number;
  incorrect: number;
};

export type TQuizz = {
  id: string;
  question: string;
  answer_0: string;
  answer_1: string;
  answer_2: string;
  answer_3: string;
  correct_answer: number;
  created_at: string;
  updated_at: string;
};

export interface IQuizzStore {
  quizzes: TQuizz[] | null;
  setQuizzes: (quizzes: TQuizz[]) => void;
  availableAt: string | null;
  availableUntil: string | null;
  setAvailableState: (
    availableAt: string | null,
    availableUntil: string | null,
  ) => void;
}

export const useQuizzStore = create<IQuizzStore>((set) => ({
  quizzes: null,
  setQuizzes: (quizzes) => set({ quizzes }),
  availableAt: null,
  availableUntil: null,
  setAvailableState: (availableAt, availableUntil) =>
    set({ availableAt, availableUntil }),
}));
